import React from 'react';
import PropTypes from 'prop-types';
import { allowedMessageProps } from '../../lists/SystemMessages';
import { allowedLanguages } from '../../../languages';
import withLocalization from '../../higherOrderComponents/withLocalization';
import DropdownArea from '../DropdownArea';
import { Button } from '../ActionElement';
import InputFieldDefault from './_InputFieldDefault';
import PasswordStrengthMeter from './_PasswordStrengthMeter';
import { transformFirstLetter } from '../../../common/utils';

class InputFieldPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      isPasswordVisible: false,
      isInputFocused: false,
      isButtonFocused: false
    };

    this.setFocusState = this.setFocusState.bind(this);
  }

  setFocusState(element, isFocused) {
    if (element !== 'input' && element !== 'button') {
      throw new Error(`Invalid focusable element type: ${element}`);
    }

    this.setState({
      [`is${transformFirstLetter(element, 'upper')}Focused`]: isFocused
    });
  }

  render() {
    const {
      props,
      state: {
        isPasswordVisible,
        isInputFocused,
        isButtonFocused
      },
      setFocusState
    } = this;

    const {
      language,
      translate,
      inputAttributes,
      message,
      checkPasswordStrength,
      customChangeHandler
    } = props;

    const finalInputAttributes = {
      ...inputAttributes,
      'aria-invalid': !!message,
      onFocus: () => setFocusState('input', true),
      onBlur: () => setFocusState('input', false)
    };

    if (customChangeHandler) {
      finalInputAttributes.onChange = function ({ target: { value } }) {
        customChangeHandler({ value });
      };
    }

    if (isPasswordVisible) {
      finalInputAttributes.type = 'text';
    }

    const inputFieldProps = {
      ...props,
      inputAttributes: finalInputAttributes
    };

    return (
      <React.Fragment>
        <div className='buttoned-input-wrap'>
          <InputFieldDefault {...inputFieldProps} />
          <Button
            onClick={() => this.setState({ isPasswordVisible: !isPasswordVisible })}
            disabled={false}
            appearance='buttonWrap'
            iconName={`eye${isPasswordVisible ? '-slash' : ''}`}
            title={translate(`input-password-button-${isPasswordVisible ? 'hide' : 'show'}-title`)}
            aria-expanded={isPasswordVisible}
            onFocus={() => setFocusState('button', true)}
            onBlur={() => setFocusState('button', false)}
            sameTextAndIconColor={false}
          />
        </div>

        {!checkPasswordStrength ? null : (
          <DropdownArea
            isOpen={isInputFocused || isButtonFocused}
            classNames={['border-0']}
          >
            <PasswordStrengthMeter
              value={finalInputAttributes.value}
              language={language}
            />
          </DropdownArea>
        )}
      </React.Fragment>
    );
  }
}

InputFieldPassword.propTypes = {
  language: PropTypes.oneOf(allowedLanguages).isRequired,
  inputAttributes: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool
    ]).isRequired
  }).isRequired,
  description: PropTypes.string.isRequired,
  message: PropTypes.shape(allowedMessageProps),
  customChangeHandler: PropTypes.func
};

export default withLocalization(InputFieldPassword, 'elements/customInput');